import {BlogStatusConfig} from "../lib/blogStatus";

export const StatusBadge = ({ status, responsive = false }) => {
  const config =  BlogStatusConfig[status.id]
  if (!config) {
    return null;
  }
  const { label, style: s } = BlogStatusConfig[status.id];
  return (
    <span 
      className={`status-badge ${responsive ? 'status-badge--responsive' : ''}`}
      style={{
      background: s.bg, 
      border: `1px solid ${s.border}`,
      color: s.color,
    }}>
      {label}
    </span>
  );
}